/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_PatternInputs */

const vi_tea_purchase_pattern = /** @type {(inputs: Tea_Purchase_PatternInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vụ thu hoạch`)
};

/**

* @param {Tea_Purchase_PatternInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_pattern = /** @type {((inputs?: Tea_Purchase_PatternInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_PatternInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_pattern(inputs)
});